export default __webpack_public_path__ + "static/media/AR-6.ba076afe.jpg";